























































































































































































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import MessageData from '@/data/MessageData';
import AnnouncementModule from '@/store/modules/Announcement';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class GameMessage extends Mixins(ErrorHandleMixin) {
  TableHead = MessageData.TableHead;

  AnnouncementInstance = getModule(AnnouncementModule, this.$store);

  mode = '';

  MessageModel = MessageData.initialModel();

  currentSelection: any = {};

  isOpenRemove = false;

  searchText = '';

  data = [];

  async created() {
    this.fetchAnnouncerment();
  }

  async fetchAnnouncerment() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AnnouncementInstance.FetchAnnouncement({ type: 'agent' });
    this.data = this.AnnouncementInstance.announcementList;
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  openModal(index) {
    this.MessageModel = MessageData.initialModel();
    this.mode = index > -1 ? 'Update' : 'Create';
    if (index > -1) {
      this.MessageModel = { ...this.AnnouncementInstance.announcementList[index] };
    }
  }

  handleSearch() {
    this.data = this.AnnouncementInstance.announcementList
      .filter((item) => item.content.includes(this.searchText));
  }

  async submit() {
    const res = await this.AnnouncementInstance[`${this.mode}Announcement`](this.MessageModel);
    this.checkError(res);
    this.mode = '';
    this.fetchAnnouncerment();
  }

  remove(item) {
    this.currentSelection = item;
    this.isOpenRemove = true;
  }

  async submitRemove() {
    const res = await this.AnnouncementInstance.DeleteAnnouncement({
      _id: this.currentSelection._id,
    });
    this.checkError(res);
    this.isOpenRemove = false;
    this.fetchAnnouncerment();
  }
}
